/* KRYØS — core interactions & motion engine */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = false; // animations toujours actives (choix client), même si l'OS demande de les réduire
  const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
  const root = document.documentElement;
  const K = (window.KY = window.KY || {});
  window.__ky = true;
  let ready = false, lenis = null;
  const readyQ = [];
  const whenReady = (fn) => (ready ? fn() : readyQ.push(fn));
  K.whenReady = whenReady;
  const hasGSAP = () => window.gsap && window.ScrollTrigger;

  /* ---------- toast ---------- */
  window.toast = K.toast = (msg) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 3400);
  };

  /* ---------- smooth scroll ---------- */
  function initLenis() {
    if (reduce || !window.Lenis || lenis) return;
    if (!fine) { initNativeAnchors(); return; }
    lenis = new Lenis({ lerp: 0.1, smoothWheel: true, wheelMultiplier: 0.95 });
    K.lenis = lenis;
    if (hasGSAP()) {
      gsap.registerPlugin(ScrollTrigger);
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((t) => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
    } else {
      (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(0);
    }
    // stop while overlays open
    new MutationObserver(() => {
      const lock = document.body.classList.contains('overflow-hidden') || $('.modal.open') || $('.mobile-menu.open');
      lock ? lenis.stop() : lenis.start();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href*="#"]');
      if (!a) return;
      const u = new URL(a.href, location.href);
      if (u.pathname !== location.pathname || !u.hash || u.hash === '#') return;
      const el = document.getElementById(u.hash.slice(1));
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -70, duration: 1.4 });
    });
  }

  function initNativeAnchors() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href*="#"]');
      if (!a) return;
      const u = new URL(a.href, location.href);
      if (u.pathname !== location.pathname || !u.hash || u.hash === '#') return;
      const el = document.getElementById(u.hash.slice(1));
      if (!el) return;
      e.preventDefault();
      scrollTo({ top: el.getBoundingClientRect().top + scrollY - 70, behavior: 'smooth' });
    });
  }

  /* ---------- preloader ---------- */
  function initPreloader() {
    const pre = $('#preloader');
    const done = () => {
      if (ready) return;
      ready = true;
      root.classList.add('ky-ready');
      if (pre) { pre.classList.add('done'); setTimeout(() => pre.remove(), 1400); }
      readyQ.splice(0).forEach((f) => { try { f(); } catch (e) { console.warn(e); } });
      window.dispatchEvent(new Event('ky:ready'));
    };
    let seen = false;
    try { seen = sessionStorage.getItem('kyPre') === '1'; } catch (e) {}
    if (!pre || reduce || (!fine && seen)) {
      if (pre) pre.style.transition = 'none';
      done();
      return;
    }
    try { sessionStorage.setItem('kyPre', '1'); } catch (e) {}
    const num = $('#preCount'), bar = $('.pre-bar i', pre);
    const t0 = performance.now(), dur = !fine ? 700 : seen ? 450 : 1700;
    let loaded = !fine || document.readyState === 'complete';
    addEventListener('load', () => (loaded = true));
    (function tick(t) {
      let p = Math.min(1, (t - t0) / dur);
      if (!loaded && p > 0.9) p = 0.9 + (p - 0.9) * 0.1;
      const e = 1 - Math.pow(1 - p, 3);
      num.textContent = String(Math.round(e * 100)).padStart(3, '0');
      bar.style.transform = 'scaleX(' + e + ')';
      if (p >= 1 && loaded) setTimeout(done, 250);
      else if (t - t0 > 5200) done();
      else requestAnimationFrame(tick);
    })(t0);
  }

  /* ---------- split text ---------- */
  function splitEl(el) {
    if (el.dataset.kySplit) return;
    el.dataset.kySplit = '1';
    let idx = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((w) => {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(' ')); return; }
            const o = document.createElement('span'); o.className = 'ky-w';
            const i = document.createElement('span'); i.className = 'ky-wi'; i.style.setProperty('--i', idx++); i.textContent = w;
            o.appendChild(i); frag.appendChild(o);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    };
    walk(el);
    el.classList.add('split');
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
  }
  function initSplit(scope = document) {
    $$('[data-split]', scope).forEach((el) => {
      splitEl(el);
      if (el.dataset.kyObs) return;
      el.dataset.kyObs = '1';
      const go = () => whenReady(() => setTimeout(() => el.classList.add('split-in'), +(el.dataset.delay || 0)));
      if (el.hasAttribute('data-hero')) return go();
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { go(); io.disconnect(); } }), { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      io.observe(el);
    });
  }

  /* ---------- reveal / clip / counters ---------- */
  function initReveal(scope = document) {
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      const el = e.target._kyClip || e.target;
      whenReady(() => {
        const sib = [...el.parentElement.children].filter((c) => c.classList.contains('reveal') || c.classList.contains('clip'));
        const k = sib.indexOf(el);
        el.style.transitionDelay = (k > -1 ? (k % 6) * 90 : 0) + 'ms';
        el.classList.add('visible');
      });
    }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    // un élément en clip-path:inset(100%) a une surface visible nulle pour l'IntersectionObserver → on observe un proxy parent
    $$('.reveal:not([data-io]),.clip:not([data-io])', scope).forEach((el) => {
      el.dataset.io = '1';
      if (el.classList.contains('clip')) {
        const proxy = document.createElement('i');
        proxy.style.cssText = 'position:absolute;inset:0;pointer-events:none;visibility:hidden';
        const host = el.parentElement;
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        proxy._kyClip = el; host.appendChild(proxy); io.observe(proxy);
      } else io.observe(el);
    });

    const cio = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target; cio.unobserve(el);
      whenReady(() => {
        const target = parseFloat(el.dataset.count), dec = parseInt(el.dataset.dec || 0), suf = el.dataset.suffix || '';
        const t0 = performance.now(), dur = 1800;
        (function tick(t) {
          const p = Math.min(1, (t - t0) / dur), ease = 1 - Math.pow(1 - p, 4);
          el.innerHTML = (target * ease).toFixed(dec) + '<em>' + suf + '</em>';
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }), { threshold: 0.4 });
    $$('[data-count]:not([data-cio])', scope).forEach((el) => { el.dataset.cio = '1'; cio.observe(el); });
  }

  /* ---------- nav ---------- */
  function initNav() {
    const nav = $('.nav'); if (!nav) return;
    const bar = $('.nav-progress', nav);
    let last = 0;
    const onScroll = () => {
      const y = window.scrollY, h = document.documentElement.scrollHeight - innerHeight;
      if (bar) bar.style.transform = 'scaleX(' + (h > 0 ? y / h : 0) + ')';
      nav.classList.toggle('hide', y > last && y > 240 && !document.body.classList.contains('overflow-hidden'));
      last = y;
    };
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
    const burger = $('#burger'), mm = $('#mmenu');
    burger?.addEventListener('click', () => {
      const o = mm.classList.toggle('open'); burger.classList.toggle('open', o);
      burger.setAttribute('aria-expanded', o);
    });
    mm?.addEventListener('click', (e) => { if (e.target.closest('a')) { mm.classList.remove('open'); burger.classList.remove('open'); } });
  }

  /* ---------- cursor ---------- */
  function initCursor() {
    const cur = $('.cursor'); if (!cur || !fine || reduce) return;
    root.classList.add('ky-cursor-on');
    const label = $('span', cur);
    let x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y;
    addEventListener('pointermove', (e) => { x = e.clientX; y = e.clientY; }, { passive: true });
    (function loop() { cx += (x - cx) * 0.2; cy += (y - cy) * 0.2; cur.style.transform = `translate(${cx}px,${cy}px)`; requestAnimationFrame(loop); })();
    addEventListener('pointerdown', () => cur.classList.add('down'));
    addEventListener('pointerup', () => cur.classList.remove('down'));
    document.addEventListener('pointerover', (e) => {
      const t = e.target.closest('[data-cursor]');
      if (t) { label.textContent = t.dataset.cursor; cur.classList.add('label'); cur.classList.remove('big'); return; }
      cur.classList.remove('label');
      cur.classList.toggle('big', !!e.target.closest('a,button,.btn,.step,.chip,.opt,.faq,input,select,textarea,label'));
    });
  }

  /* ---------- magnetic + tilt ---------- */
  function initPointerFx(scope = document) {
    if (!fine || reduce) return;
    $$('.btn:not([data-mg]),.nav-ico:not([data-mg]),.magnetic:not([data-mg])', scope).forEach((el) => {
      el.dataset.mg = '1';
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        el.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.28}px,${(e.clientY - r.top - r.height / 2) * 0.4}px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transition = 'transform .6s var(--ease)'; el.style.transform = ''; setTimeout(() => (el.style.transition = ''), 600); });
    });
    $$('[data-tilt]:not([data-tl])', scope).forEach((el) => {
      el.dataset.tl = '1';
      if (!$('.glare', el)) { const g = document.createElement('i'); g.className = 'glare'; el.appendChild(g); }
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        el.style.transform = `perspective(1000px) rotateX(${(0.5 - py) * 7}deg) rotateY(${(px - 0.5) * 9}deg) translateZ(0)`;
        el.style.setProperty('--gx', px * 100 + '%'); el.style.setProperty('--gy', py * 100 + '%');
      });
      el.addEventListener('pointerleave', () => { el.style.transition = 'transform .8s var(--ease),opacity .5s'; el.style.transform = ''; setTimeout(() => (el.style.transition = ''), 800); });
    });
  }

  /* ---------- GSAP scroll effects ---------- */
  function initScrollFx() {
    if (!hasGSAP() || reduce) return;
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });
    const desk = fine && matchMedia('(min-width:1001px)').matches;
    // parallax
    $$('[data-parallax]').forEach((el) => {
      const s = parseFloat(el.dataset.parallax) || 0.15;
      gsap.fromTo(el, { yPercent: -s * 100 }, { yPercent: s * 100, ease: 'none', scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    // manifesto words
    $$('[data-manifesto]').forEach((el) => {
      const html = el.innerHTML;
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const out = [];
      const walk = (n, wrap) => n.childNodes.forEach((c) => {
        if (c.nodeType === 3) c.textContent.split(/\s+/).filter(Boolean).forEach((w) => { const s = document.createElement('span'); s.className = 'mf-w'; s.textContent = w; wrap.appendChild(s); wrap.appendChild(document.createTextNode(' ')); out.push(s); });
        else if (c.nodeType === 1) { const cl = c.cloneNode(false); wrap.appendChild(cl); walk(c, cl); }
      });
      const holder = document.createElement('div'); walk(tmp, holder); el.innerHTML = holder.innerHTML;
      const words = $$('.mf-w', el);
      gsap.to(words, { opacity: 1, stagger: 0.12, ease: 'none', scrollTrigger: { trigger: el, start: 'top 78%', end: 'bottom 50%', scrub: 0.4 } });
    });
    // teardown scrollytelling
    if (matchMedia('(min-width:1001px)').matches) {
      $$('.steps.scrolly').forEach((wrap) => {
        $$('.step', wrap).forEach((s) => ScrollTrigger.create({ trigger: s, start: 'top 58%', end: 'bottom 58%', onToggle: (self) => { if (self.isActive) K.setStep(s); } }));
      });
    }
    // giant footer text drift
    const fg = $('.foot-giant');
    if (fg) gsap.fromTo(fg, { xPercent: 6 }, { xPercent: -6, ease: 'none', scrollTrigger: { trigger: fg, start: 'top bottom', end: 'bottom bottom', scrub: true } });
    // hero viewer scroll drift
    const hv = desk && $('.hero-viewer');
    if (hv) gsap.to(hv, { yPercent: -8, ease: 'none', scrollTrigger: { trigger: '.hero-sec', start: 'top top', end: 'bottom top', scrub: true } });
    const hc = desk && $('.hero-copy');
    if (hc) gsap.to(hc, { yPercent: 10, opacity: 0.25, ease: 'none', scrollTrigger: { trigger: '.hero-sec', start: '30% top', end: 'bottom top', scrub: true } });
    ScrollTrigger.refresh();
  }

  /* ---------- teardown steps ---------- */
  K.setStep = (s) => {
    const wrap = s.closest('.explo') || document;
    $$('.step', wrap).forEach((x) => x.classList.remove('active')); s.classList.add('active');
    const v = $('.explo-view', wrap); if (v) v.dataset.active = s.dataset.step;
    const vid = $('[data-explo-video]', wrap);
    if (vid) K.videoTo(vid, parseFloat(s.dataset.t) || 0);
    const label = $('.step-label', wrap);
    if (label) label.textContent = '0' + s.dataset.step + ' / 04 — ' + s.querySelector('h4').textContent;
    const txt = $('.step-text', wrap), p = s.querySelector('p');
    if (txt && p) txt.textContent = p.textContent;
  };
  /* vidéo de l'éclaté : lecture jusqu'au temps de l'étape, puis pause (retour arrière = saut direct) */
  K.videoTo = (v, target) => {
    cancelAnimationFrame(v._kyRaf);
    if (!v.duration && v.readyState < 1) { v.addEventListener('loadedmetadata', () => K.videoTo(v, target), { once: true }); return; }
    target = Math.min(target, (v.duration || target) - 0.05);
    if (target <= v.currentTime + 0.04) { v.pause(); v.currentTime = target; return; }
    v.play().catch(() => {});
    const stop = () => { if (v.currentTime >= target) { v.pause(); v.currentTime = target; } else v._kyRaf = requestAnimationFrame(stop); };
    stop();
  };
  function initSteps() {
    $$('.step').forEach((s) => { if (s.dataset.st) return; s.dataset.st = '1'; s.addEventListener('click', (e) => { if (e.isTrusted) s.closest('.explo')?.classList.add('ky-manual'); K.setStep(s); }); });
    if (!matchMedia('(max-width:1000px)').matches) return;
    $$('.explo:not([data-auto])').forEach((ex) => {
      ex.dataset.auto = '1';
      let timer = 0;
      const next = () => { if (ex.classList.contains('ky-manual')) return clearInterval(timer); const st = $$('.step', ex), i = st.findIndex((x) => x.classList.contains('active')); K.setStep(st[(i + 1) % st.length]); };
      new IntersectionObserver((es) => { clearInterval(timer); if (es[0].isIntersecting) timer = setInterval(next, 3200); }, { threshold: 0.5 }).observe(ex);
    });
  }

  /* ---------- chips (filter grids) ---------- */
  function initChips() {
    $$('.matcher-filters').forEach((bar) => {
      if (bar.dataset.ch) return; bar.dataset.ch = '1';
      const grid = bar.parentElement.querySelector('.match-grid') || document.querySelector('.match-grid');
      $$('.chip[data-filter]', bar).forEach((c) => c.addEventListener('click', () => {
        $$('.chip', bar).forEach((x) => x.classList.remove('active')); c.classList.add('active');
        const f = c.dataset.filter;
        $$('.product[data-habitat]', grid).forEach((p) => {
          const show = f === 'all' || (p.dataset.habitat || '').split(' ').includes(f);
          if (show) { p.style.display = ''; requestAnimationFrame(() => requestAnimationFrame(() => p.classList.remove('is-hidden'))); }
          else { p.classList.add('is-hidden'); setTimeout(() => { if (p.classList.contains('is-hidden')) p.style.display = 'none'; }, 420); }
        });
        setTimeout(() => window.ScrollTrigger && ScrollTrigger.refresh(), 500);
      }));
      const want = new URLSearchParams(location.search).get('f'), pre = want && $('.chip[data-filter="' + want + '"]', bar);
      if (pre) pre.click();
    });
  }

  /* ---------- description produit repliée sur mobile ---------- */
  function initMore(scope = document) {
    if (!matchMedia('(max-width:700px)').matches) return;
    $$('.ky-product .prose:not([data-more])', scope).forEach((p) => {
      p.dataset.more = '1';
      p.classList.add('ky-clamp');
      if (p.scrollHeight <= p.clientHeight + 4) { p.classList.remove('ky-clamp'); return; }
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'ky-more'; b.textContent = 'Lire la suite +';
      b.addEventListener('click', () => { const open = p.classList.toggle('ky-clamp'); b.textContent = open ? 'Lire la suite +' : 'Réduire −'; window.ScrollTrigger && ScrollTrigger.refresh(); });
      p.after(b);
    });
  }

  /* ---------- faq ---------- */
  function initFaq() {
    $$('.faq').forEach((f) => {
      if (f.dataset.fq) return; f.dataset.fq = '1';
      f.addEventListener('click', () => {
        const box = $('.fa', f), open = f.classList.toggle('open');
        box.style.height = open ? box.scrollHeight + 'px' : '0px';
        setTimeout(() => window.ScrollTrigger && ScrollTrigger.refresh(), 600);
      });
    });
  }

  /* ---------- modal (lead capture) ---------- */
  function initModal() {
    const m = $('#modalAccess'); if (!m) return;
    const close = () => { m.classList.remove('open'); document.body.classList.remove('ky-modal'); };
    $$('[data-open-modal]').forEach((b) => {
      if (b.dataset.mo) return; b.dataset.mo = '1';
      b.addEventListener('click', (e) => {
        e.preventDefault();
        const tag = b.dataset.tag || 'newsletter';
        const tagInput = $('input[name="contact[tags]"]', m);
        const sel = $('select[name="ky_model"]', m);
        if (b.dataset.title) $('[data-m-title]', m).textContent = b.dataset.title;
        if (b.dataset.desc) $('[data-m-desc]', m).textContent = b.dataset.desc;
        if (sel) { $('.field-model', m).style.display = b.dataset.model === 'off' ? 'none' : ''; if (b.dataset.model && b.dataset.model !== 'off') sel.value = b.dataset.model; }
        tagInput.dataset.base = tag; tagInput.value = tag + (sel && b.dataset.model !== 'off' ? ',' + sel.value : '');
        m.classList.add('open'); document.body.classList.add('ky-modal');
        lenis && lenis.stop();
      });
    });
    const sel = $('select[name="ky_model"]', m);
    sel?.addEventListener('change', () => { const t = $('input[name="contact[tags]"]', m); t.value = (t.dataset.base || 'newsletter') + ',' + sel.value; });
    m.addEventListener('click', (e) => { if (e.target === m || e.target.closest('.modal-close')) { close(); lenis && lenis.start(); } });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && m.classList.contains('open')) { close(); lenis && lenis.start(); } });
    if ($('.form-ok', m)) { m.classList.add('open'); lenis && lenis.stop(); }
  }

  /* ---------- page transitions ---------- */
  function initTransitions() {
    const cur = $('.ky-curtain'); if (!cur || reduce) return;
    addEventListener('pageshow', () => cur.classList.remove('on'));
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target === '_blank' || a.hasAttribute('download') || a.getAttribute('role') === 'button') return;
      let u; try { u = new URL(a.href, location.href); } catch (er) { return; }
      if (u.origin !== location.origin) return;
      if (/\/(checkout|cart\/(add|change|update|clear)|account\/logout)/.test(u.pathname)) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      e.preventDefault();
      cur.classList.add('on');
      setTimeout(() => (location.href = a.href), 560);
    });
  }

  /* ---------- lead forms feedback ---------- */
  function initForms() {
    if (/customer_posted=true/.test(location.search)) whenReady(() => setTimeout(() => toast('Merci, votre inscription est enregistrée.'), 600));
    if (/contact_posted=true/.test(location.hash + location.search)) whenReady(() => setTimeout(() => toast('Message envoyé. Nous vous répondons par e-mail.'), 600));
  }

  /* ---------- quick add (accessories) ---------- */
  K.addToCart = async function (items) {
    const res = await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Erreur panier');
    const drawer = $('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      try { drawer.classList.remove('is-empty'); drawer.renderContents(data); return data; } catch (e) { console.warn(e); }
    }
    // fallback: refresh bubble then go to cart
    location.href = window.routes.cart_url;
    return data;
  };
  function initQuickAdd(scope = document) {
    $$('[data-quick-add]:not([data-qa])', scope).forEach((b) => {
      b.dataset.qa = '1';
      b.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopPropagation();
        const old = b.textContent; b.textContent = '…'; b.disabled = true;
        try { await K.addToCart([{ id: +b.dataset.quickAdd, quantity: 1 }]); b.textContent = '✓ Ajouté'; }
        catch (er) { toast(er.message); b.textContent = old; }
        setTimeout(() => { b.textContent = old; b.disabled = false; }, 1800);
      });
    });
  }


  /* ---------- loupe (module anatomie) ---------- */
  function initLoupe(scope = document) {
    $$('[data-loupe]:not([data-lp])', scope).forEach((st) => {
      st.dataset.lp = '1';
      const img = $('.anat-img', st), lp = $('.loupe', st), Z = 3;
      lp.style.backgroundImage = `url("${st.dataset.src}")`;
      const move = (x, y) => {
        const s = st.getBoundingClientRect(), r = img.getBoundingClientRect();
        lp.style.left = x - s.left + 'px'; lp.style.top = y - s.top + 'px';
        lp.style.backgroundSize = `${r.width * Z}px ${r.height * Z}px`;
        const px = (x - r.left) * Z - 110, py = (y - r.top) * Z - 110;
        lp.style.backgroundPosition = `${-px}px ${-py}px`;
      };
      st.addEventListener('pointerenter', () => { st.classList.add('on'); document.documentElement.classList.add('ky-loupe'); });
      st.addEventListener('pointerleave', () => { st.classList.remove('on'); document.documentElement.classList.remove('ky-loupe'); });
      st.addEventListener('pointermove', (e) => { st.classList.add('on'); move(e.clientX, e.clientY); });
      st.addEventListener('pointerdown', (e) => { st.classList.add('on'); move(e.clientX, e.clientY); });
    });
  }

  /* ---------- visionneuse photos (zoom au clic) ---------- */
  document.addEventListener('ky:model', (e) => {
    const t = e.detail.tex;
    $$('[data-loupe]').forEach((st) => { st.dataset.src = t; const im = $('.anat-img', st); if (im) im.src = t; const lp = $('.loupe', st); if (lp) lp.style.backgroundImage = `url("${t}")`; });
    $$('.ruler-lure img').forEach((im) => (im.src = t));
  });
  function initLightbox() {
    const links = $$('a[data-lb]');
    if (!links.length || $('.ky-lb')) return;
    const lb = document.createElement('div'); lb.className = 'ky-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="lb-fig"><img alt=""></div><button class="lb-x" aria-label="Fermer">✕</button><button class="lb-p" aria-label="Précédente">←</button><button class="lb-n" aria-label="Suivante">→</button><div class="lb-c"></div>';
    document.body.appendChild(lb);
    const fig = $('.lb-fig', lb), im = $('img', lb), cnt = $('.lb-c', lb);
    let i = 0;
    const show = (k) => { i = (k + links.length) % links.length; fig.classList.remove('zoomed'); im.src = links[i].href; im.alt = $('img', links[i])?.alt || ''; cnt.textContent = `${String(i + 1).padStart(2, '0')} / ${String(links.length).padStart(2, '0')} — CLIC POUR ZOOMER`; };
    const close = () => { lb.classList.remove('open'); window.KY?.lenis?.start(); };
    links.forEach((a, k) => a.addEventListener('click', (e) => { e.preventDefault(); show(k); lb.classList.add('open'); window.KY?.lenis?.stop(); }));
    fig.addEventListener('click', (e) => { const r = fig.getBoundingClientRect(); fig.style.setProperty('--ox', ((e.clientX - r.left) / r.width) * 100 + '%'); fig.style.setProperty('--oy', ((e.clientY - r.top) / r.height) * 100 + '%'); fig.classList.toggle('zoomed'); });
    fig.addEventListener('pointermove', (e) => { if (!fig.classList.contains('zoomed')) return; const r = fig.getBoundingClientRect(); fig.style.setProperty('--ox', ((e.clientX - r.left) / r.width) * 100 + '%'); fig.style.setProperty('--oy', ((e.clientY - r.top) / r.height) * 100 + '%'); });
    $('.lb-x', lb).onclick = close; $('.lb-p', lb).onclick = () => show(i - 1); $('.lb-n', lb).onclick = () => show(i + 1);
    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
    addEventListener('keydown', (e) => { if (!lb.classList.contains('open')) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(i - 1); if (e.key === 'ArrowRight') show(i + 1); });
  }

  /* ---------- year ---------- */
  const setYear = () => $$('[data-year]').forEach((el) => (el.textContent = new Date().getFullYear()));

  /* ---------- boot ---------- */
  function boot() {
    initLenis();
    initPreloader();
    initNav(); initCursor(); initTransitions(); initForms();
    K.init();
    initScrollFx();
    window.addEventListener('load', () => window.ScrollTrigger && ScrollTrigger.refresh());
  }
  K.init = function (scope) {
    initSplit(scope); initReveal(scope); initPointerFx(scope); initSteps(); initChips(); initMore(scope); initFaq(); initModal(); initQuickAdd(scope); initLoupe(scope); initLightbox(); setYear();
  };
  document.addEventListener('shopify:section:load', (e) => { K.init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
